import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Fetches audit logs for a specific approval person invoice
 * @param {string} invoiceNumber - The invoice number
 * @returns {Promise} - API response containing audit logs
 */
export const getApprovalPersonInvoiceAuditLogs = async (invoiceNumber) => {
  try {
    const response = await apiClient.get(
      `/approvalPersonSystemInvoiceManagement/invoice/audit-logs/${invoiceNumber}`
    );

    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
